import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-characters-counter',
  templateUrl: './characters-counter.component.html',
})
export class CharactersCounterComponent implements OnChanges, OnInit {
  @Input() maxChar?: number;
  @Input() hasSegments?: boolean = false;
  @Input() currentChar?: number;
  @Output() errors = new EventEmitter<string>();

  segments: number = 1;

  ngOnInit() {
    if (this.hasSegments && this.currentChar && this.maxChar) {
      this.segments = Math.floor(this.currentChar / this.maxChar) + 1;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentChar'] || changes['maxChar']) {
      this.handleCharacterCount(this.currentChar);
    }
  }

  private handleCharacterCount(charCount: any) {
    if (this.hasSegments && this.maxChar && this.maxChar > 0) {
      const count = charCount || 0;
      this.segments = Math.floor(count / this.maxChar) + 1;
    }
  }

  get array(): number[] {
    return Array(this.segments)
      .fill(0)
      .map((x, i) => i);
  }

  get totalPartial(): number {
    if (!this.maxChar || this.currentChar === undefined) return 0;
    const partial = this.currentChar - this.maxChar * (this.segments - 1);
    return Math.max(0, partial);
  }
}
